import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { ArrowRight } from 'react-feather';

import * as styles from './PromotionCard.module.scss';

type OfferCardProps = {
  sub_title: string;
  title: string;
  expires_at: string | null;
  href: string;
  mobile?: boolean;
  showCountdown?: boolean;
};

type TimeLeft = {
  days: number;
  hours: number;
  minutes: number;
};

export const PromotionCard = ({ sub_title, title, expires_at, href, mobile, showCountdown }: OfferCardProps) => {
  const calculateTimeLeft = (): TimeLeft => {
    if (!expires_at) {
      return { days: 0, hours: 0, minutes: 0 };
    }

    const now = new Date();
    const target = new Date(expires_at);
    const diff = target.getTime() - now.getTime();

    if (diff <= 0) {
      return { days: 0, hours: 0, minutes: 0 };
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);

    return { days, hours, minutes };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [isExpired, setIsExpired] = useState(!expires_at || new Date(expires_at) < new Date());

  useEffect(() => {
    if (!expires_at) return;

    const interval = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);
      if (newTimeLeft.days === 0 && newTimeLeft.hours === 0 && newTimeLeft.minutes === 0) {
        setIsExpired(true);
      }
    }, 60_000); // Update every minute

    return () => clearInterval(interval);
  }, [expires_at]);

  return (
    <a href={href} className={classnames(styles.root, mobile && styles.mobile)}>
      <div className={styles.container}>
        {expires_at && !isExpired && showCountdown ? (
          <div className={styles.countdown}>
            <div className={styles.countdownItem}>
              <p className={styles.countdownValue}>{timeLeft.days}</p>
              <p className={styles.countdownLabel}>dd</p>
            </div>
            <div className={styles.countdownItem}>
              <p className={styles.countdownValue}>{timeLeft.hours}</p>
              <p className={styles.countdownLabel}>hh</p>
            </div>
            <div className={styles.countdownItem}>
              <p className={styles.countdownValue}>{timeLeft.minutes}</p>
              <p className={styles.countdownLabel}>mm</p>
            </div>
          </div>
        ) : null}
        <div>
          <p className={styles.title}>
            {title}
            <ArrowRight color="#fff" />
          </p>
          <p className={styles.subtitle}>{sub_title}</p>
        </div>
      </div>
    </a>
  );
};
